module.exports = __webpack_public_path__ + "static/img/ThinkPad_X1_Carbon.cf371274.png";